<template>
  <div class="item-box-content">
    <div style="position:relative;">
      <div class="title-font-style" style="margin-bottom:20px;">
        <span>采购区</span>
      </div>
      <div style="position:absolute;top:0;right:0;">
          <el-button
          type='primary'
          @click="importProduct"
          style="margin-bottom:20px;"
        >导入产品</el-button>
        <el-button
          @click="moveOutClick"
          :disabled="dataList.length===0"
          style="margin-bottom:20px;"
        >移出采购区</el-button>

      </div>
      <el-table
        border
        ref="tableRef"
        :data="dataList"
        :summary-method="getSummaries"
        max-height="378"
        tooltip-effect="dark"
        show-summary
        :header-cell-style="tableHeader"
        @selection-change="handleSelectionChange"
        @row-dblclick="RowDbclick"
      >
        <template slot="empty">
          <no-data :nodata="`nodataPurchase`">请选择采购产品</no-data>
        </template>
        <el-table-column fixed type="selection" width="55"></el-table-column>
        <el-table-column show-overflow-tooltip prop="ocspCode" min-width="120" label="工单编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="stockupType" label="备货方式"></el-table-column>
        <el-table-column show-overflow-tooltip prop="brandName" label="品牌"></el-table-column>
        <el-table-column show-overflow-tooltip prop="proType" label="型号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="orderNumber" label="订货号"></el-table-column>
        <el-table-column prop="cbExtimeValue" label="货期">
          <template slot-scope="scope">{{scope.row.cbExtimeValue+'天'}}</template>
        </el-table-column>
        <el-table-column prop="stockupCount" label="数量">
          <template slot-scope="scope">
            <el-input-number
              style="width:100%"
              v-model="scope.row.stockupCount"
              :controls="false"
              :precision="0"
              :max="scope.row.count"
              :min="0"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="cbPrice" label="采购单价">
          <template slot-scope="scope">
            <el-input-number
              style="width:100%"
              v-model="scope.row.cbPrice"
              :controls="false"
              :precision="2"
              :min="0"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop label="采购总额">
          <template slot-scope="scope">
            <span>{{ (scope.row.stockupCount * scope.row.cbPrice) |priceFilterNum}}</span>
          </template>
        </el-table-column>
        <el-table-column prop='createUser' label="发起人"></el-table-column>
        <el-table-column prop="cbPriceSource" label="询价来源">
          <template slot-scope="scope">
            {{
            cbPriceSource[
            scope.row.cbPriceSource - 1
            ]
            }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="suName" label="询价供应商"></el-table-column>
        <el-table-column show-overflow-tooltip prop="storageName" label="备货地址"></el-table-column>
        <el-table-column prop="deliveryTime" label="预计发货时间" width="120px">
          <template slot-scope="scope">{{scope.row.deliveryTime|dateFilter}}</template>
        </el-table-column>
      </el-table>
      <div style="margin-top:20px;">
        <el-button :disabled="dataList.length===0" @click="generateContact" type="primary">生成合同</el-button>
        <div style="display: flex;padding-bottom:5px;">
          <i class="el-icon-warning-outline" style=" margin-top: 12px;"></i>
          <span class="look-text">提示：只允许相同备货方式和备货仓库的产品生成采购合同</span>
        </div>
      </div>
    </div>
        <!-------------- 导入 -------------->
    <lead-in @onRefresh="onRefresh" ref="leadInRefs"></lead-in>

  </div>
</template>
<script>
import { formatDate } from '@/util/tool'
import { deepClone } from '@/util'
import noData from '@/components/module/noData'
import leadIn from '@/components/leadIn/index'

export default {
  props: ['dataList'],
  components: { noData, 'lead-in': leadIn },
  data () {
    return {
      total: 0,
      currentPage: 1,
      moveList: [],
      pageSize: 30,
      cbPriceSource: ['系统', '人工', '特价审批', '其他', '库存']
    }
  },
  watch: {
    dataList: {
      handler (newVal) {
        newVal.forEach((element, index) => {
          if (element.stockupCount === undefined) {
            this.dataList[index].stockupCount = 0
          }
          if (element.cbPrice === undefined) {
            this.dataList[index].cbPrice = 0
          }
        })
        for (let i = 0; i < this.dataList.length; i++) {
          if (this.dataList[i].stockupCount === 0) {
            this.dataList.splice(i, 1)
            i--
          }
        }
      },
      deep: true
    }
  },
  mounted () {
    this.total = 1
  },
  methods: {
    generateContact () {
      this.$store.state.generateContactList = this.dataList

      this.$router.push({
        name: 'createContract',
        query: { type: '生成合同', data: 'purchase' }
      })
    },

    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计'
          return
        }

        const values = []
        data.forEach(item => {
          const params = {}
          params.cbPrice = Number(item.cbPrice)
          params.stockupCount = Number(item.stockupCount)
          values.push(params)
        })

        if (index === 9) {
          sums[index] = 0
          values.forEach(prev => {
            sums[index] += (prev.cbPrice * prev.stockupCount)
          })
          sums[index] = sums[index].toFixed(2)
        } else if (index === 7) {
          sums[index] = param.data.reduce((tot, prov) => {
            return tot + +(prov.stockupCount)
          }, 0)
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    moveOutClick () {
      if (this.moveList.length !== 0) {
        const params = deepClone(this.moveList)
        for (let i = 0; i < params.length; i++) {
          for (let j = 0; j < this.dataList.length; j++) {
            if (params[i].ocspId === this.dataList[j].ocspId) {
              this.dataList.splice(j, 1)
              j--
            }
          }
        }
        this.moveList = []
      } else {
        this.$message.error('请选中要移出采购区的产品！')
      }
    },
    // 导入产品
    importProduct() {
      this.$refs.leadInRefs.onLeadIn(
        this.$store.state.purchasePlanGuidIn,
        '采购清单-待采购导入产品'
      )
    },
    onRefresh(data) {
      this.$emit('onRefresh', data)
    },
    RowDbclick (row) {
      const params = deepClone([row])
      for (let i = 0; i < params.length; i++) {
        for (let j = 0; j < this.dataList.length; j++) {
          if (params[i].ocspId === this.dataList[j].ocspId) {
            this.dataList.splice(j, 1)
            j--
          }
        }
      }
    },
    handleSelectionChange (value) {
      this.moveList = value
    },

    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd')
  }
}
</script>
<style lang="scss" scoped>
.look-text {
  margin-top: 10px;
  font-size: 12px;
  color: #d35e5e;
  height: 20px;
  line-height: 20px;
}
</style>
